<template>
  <dataset-wrapper
    :type="type"
    :mode="mode"
    :resource-id="resourceId"
  >
    <station-download-stepper />
  </dataset-wrapper>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StationDownloadStepper from '@/components/station/StationDownloadStepper.vue';
import DatasetWrapper from '@/components/DatasetWrapper.vue';


export default defineComponent({
  name: 'StationView',
  components: {
    DatasetWrapper,
    StationDownloadStepper,
  },
  props: {
    type: { type: String, required: true },
    mode: { type: String, required: true },
    resourceId: { type: String, required: true },
  },
})
</script>
